import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useAnimal from "common/hooks/useAnimal";
import AnimalForm from "pages/Animals/AnimalForm";
import { useLocation } from "react-router-dom";
import { ImportItemStatus } from "types/Import";
import fetchJSON from "common/utils/fetchJSON";

function ImportDetailZims() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);
  const { refreshAnimals } = useAnimal();
  const { state } = useLocation();

  const id = router.query.id as string;
  const animalId = router.query.animalId as string;

  const {
    item: importItem,
    error: importError,
    isFetching: importIsFetching,
  }: any = useItem("imports", id, {
    listenToEvents: [
      "import_file_imported",
      "import_file_new_data",
      "import_file_imported_with_error",
      "import_file_updated",
    ],
  });

  const { saveItem, updateItem, error, isFetching }: any = useItem(
    "animals",
    animalId,
    {}
  );

  useEffect(() => {
    if (error || importError) {
      setAlert(error ?? importError, "danger");
    }
  }, [error, importError, setAlert]);

  const back = useCallback(() => {
    if (!error || !importError) {
      setAlert(t("common.saved"), "success");
      router.navigate(-1);
    }
  }, [error, importError, setAlert, t, router]);

  // Ici on vient mettre à jour le status de l'import
  const updateImportStatus = useCallback(
    async (newAnimal: any) => {
      try {
        const updatedData = importItem?.parsedContent?.data?.map(
          (data: any) => {
            return data.zimsId === newAnimal.zimsId
              ? { ...data, status: ImportItemStatus.IMPORTED }
              : data;
          }
        );

        await fetchJSON({
          url: `imports/update-status`,
          method: "PUT",
          payload: {
            data: {
              ...importItem,
              parsedContent: {
                ...importItem?.parsedContent,
                data: updatedData,
              },
            },
          },
        });
      } catch (err) {
        console.error("Update import status error:", err);
      }
    },
    [importItem]
  );

  const onSubmit = useCallback(
    async (dataAnimal: any) => {
      const newAnimal = { ...dataAnimal };

      try {
        if (newAnimal.id) {
          await updateItem(newAnimal.id, newAnimal);
        } else {
          await saveItem(newAnimal);
        }
        updateImportStatus(newAnimal);
      } catch (e: any) {
        return e;
      }
      refreshAnimals();
      back();
      return true;
    },
    [refreshAnimals, back, updateImportStatus, updateItem, saveItem]
  );

  const formatedImportedValues = useMemo(
    () => ({
      ...state.selectedItem,
    }),
    [state]
  );

  return isFetching || importIsFetching || (id && !importItem) ? null : (
    <AnimalForm
      onSubmit={onSubmit}
      animal={formatedImportedValues}
      isFromImport
    />
  );
}

export default ImportDetailZims;
